<!-- EF-3852 — dans la popin, titre et sous-titre sont portés par la popin elle-même (maquette « Popin Onboarding »). -->
@if (!embedded()) {
    <eb-h2
        data-testid="profile-professional-info-title"
        class="profile-professional-info__title"
        >{{ titleKey() | transloco }}</eb-h2
    >
    @if (subtitleKey(); as subtitle) {
        <p
            data-testid="profile-professional-info-subtitle"
            class="profile-professional-info__subtitle"
        >
            {{ subtitle | transloco }}
        </p>
    }
}

<form
    class="profile-professional-info__form"
    [formGroup]="form"
>
    <header class="profile-professional-info__header">
        <eb-profile-photo
            [firstName]="firstName()"
            [lastName]="lastName()"
            [photo]="photo()"
            (photoChange)="onPhotoChange($event)"
        />
        <div class="profile-professional-info__identity">
            <span class="profile-professional-info__name">{{ displayName() }}</span>
            @if (registrationNumber()) {
                <span class="profile-professional-info__registration"> {{ 'profile.professional_info.registration_number' | transloco }} {{ registrationNumber() }} </span>
            }
        </div>
    </header>

    @if (!embedded()) {
        <hr class="profile-professional-info__divider" />
    }

    <div class="profile-professional-info__grid profile-professional-info__grid--two">
        <eb-material-input-text
            [label]="'profile.professional_info.last_name' | transloco"
            formControlName="lastName"
            labelPosition="top"
        />
        <eb-material-input-text
            [label]="'profile.professional_info.first_name' | transloco"
            formControlName="firstName"
            labelPosition="top"
        />
    </div>

    <div class="profile-professional-info__grid profile-professional-info__grid--two profile-professional-info__grid--contact">
        <eb-material-input-text
            [label]="'profile.professional_info.email' | transloco"
            formControlName="professionalEmail"
            labelPosition="top"
        />
        <eb-material-input-phone-number
            [label]="'profile.professional_info.phone' | transloco"
            defaultCountry="FR"
            formControlName="professionalPhone"
        />
    </div>

    <div class="profile-professional-info__grid profile-professional-info__grid--two">
        <eb-material-input-text
            [label]="(embedded() ? 'profile.professional_info.registration_number' : 'profile.professional_info.registration_number_field') | transloco"
            [placeholder]="embedded() ? ('profile.professional_info.registration_number_placeholder' | transloco) : ''"
            formControlName="registrationNumber"
            labelPosition="top"
        />
        <div class="profile-professional-info__cif">
            <eb-label
                color="flat-secondary"
                size="sm"
                textTransform="uppercase"
                weight="black"
            >
                {{ (embedded() ? 'profile.professional_info.cif_status' : 'profile.professional_info.cif') | transloco }}
            </eb-label>
            <!-- EF-3921 : « Non » a l'aspect éteint et l'option retenue passe en gras (demande PO). -->
            <eb-switch-input
                [isSelectedLabelBold]="true"
                [leftText]="'common.yes' | transloco"
                [offValue]="false"
                [rightText]="'common.no' | transloco"
                formControlName="isCif"
            />
        </div>
    </div>

    @if (!embedded()) {
        <div class="mt-4 profile-professional-info__actions">
            @if (hasUnsavedChanges()) {
                <eb-button-with-icon
                    [label]="'common.cancel'"
                    (buttonClick)="cancelChanges()"
                    color="secondary-v2"
                    icon="ui/action/symbols/cross"
                    iconWidth="16"
                >
                    <eb-label
                        class="d-flex align-items-center p-1"
                        size="lg"
                    >
                        {{ 'common.cancel' | transloco }}
                    </eb-label>
                </eb-button-with-icon>
            }

            <span
                class="profile-professional-info__save"
                [class.profile-professional-info__save--pulse]="canSave()"
            >
                <eb-button-with-icon
                    [disabled]="!canSave()"
                    [iconButtonDisabledExplanation]="disabledExplanationKey() | transloco"
                    [label]="'common.save_changes'"
                    (buttonClick)="saveChanges()"
                    icon="ui/action/symbols/save"
                    iconWidth="16"
                >
                    <eb-label
                        class="d-flex align-items-center p-1"
                        size="lg"
                    >
                        {{ 'common.save_changes' | transloco }}
                    </eb-label>
                </eb-button-with-icon>
            </span>
        </div>
    }
</form>
